// extracted by mini-css-extract-plugin
export default {"tooltip":"SM-z","arrow":"TM-z"};